import React from 'react'

const Visited = () => {
  return (
    <div>

<section class="process-section">
        <div class="container">
            <h2>OUR SUCCESS</h2>
            <h3>See How It Works</h3>
            <div class="row justify-content-center">
                <div class="col-md-3 step">
                    <div class="step-circle">2500</div>
                    <div class="step-title">WEDDING </div>
                   
                </div>
                <div class="col-md-3 step">
                    <div class="step-circle">500</div>
                    <div class="step-title">Engagements </div>
                    
                </div>
                <div class="col-md-3 step">
                    <div class="step-circle">1000</div>
                    <div class="step-title">RECEPTIONS  </div>
                   
                </div>
                <div class="col-md-3 step">
                    <div class="step-circle">1250</div>
                    <div class="step-title">  ANNIVERSARY  </div>
                   
                </div>
            </div>
        </div>
    </section>


    </div>
  )
}

export default Visited